export function mapGetSchemaOperator(node, _ctx) {
    return {
        type: "GetSchemaOperator",
        start: node.from,
        end: node.to,
    };
}
